import { useState, useEffect, useMemo } from 'react';
import isEmpty from 'lodash/isEmpty';
import findIndex from 'lodash/findIndex';
import { useCurrentRefinements, useHits } from 'react-instantsearch';
import { Row } from '@commonsku/styles';
import ProductChevronPopup from '../product/ProductChevronPopup';
import NewProduct from '../NewProduct';
import { useProductActions } from '../product-search/shared/useProductActions';
import { getSubTitle } from '../product-search/shared/utils';
import { expandHitsByDivision } from './algoliaDivisionUtils';

function CustomHits({ loading, order, full_order, onAddItem, onDeleteItem, divisions, index, setHitLength, ...props }) {
  const { items, sendEvent, results } = useHits(props);
  const { items: currentRefinementItems } = useCurrentRefinements({
    includedAttributes: ['division_ids'],
  });
  const [selectedItem, setSelectedItem] = useState(null);

  useEffect(() => {
    if (!isEmpty(results.query)) {
      setHitLength((prev) => {
        const newArray = [...prev];
        newArray[index] = results.hits.length;
        return newArray;
      });
    }
  }, [items, results]);

  const activeDivisionIds = useMemo(() => {
    return currentRefinementItems
      .flatMap((item) => item.refinements || [])
      .map((refinement) => refinement.value)
      .filter(Boolean);
  }, [currentRefinementItems]);
  const convertedItems = expandHitsByDivision(items, divisions, activeDivisionIds);
  const displayItems = convertedItems.length > 0 ? convertedItems : items;

  const { isSelected, isItemLoading, handleClickProductAction, trackClickEvent } = useProductActions({
    order,
    fullOrder: full_order,
    onAddItem,
    onDeleteItem,
    loading,
    isProductsPage: false,
    eventPrefix: 'llm_suggestion',
    onSendConversionEvent: (item, label) => sendEvent('conversion', item, label, { eventSubtype: 'addToCart' }),
  });

  return (
    <>
      <Row style={{ gap: 28, overflow: 'hidden', height: '380px' }}>
        {displayItems.map((item) => {
          const onLoading = isItemLoading(item);

          return <NewProduct
            key={`${item.ext_product_id}-${item.division_id}`}
            title={item.product_name}
            sku={item.product_supplier_code}
            subtitle={getSubTitle(item.min_price, item.max_price)}
            description={item.division_name}
            product={item}
            loading={onLoading}
            loaded={isSelected(item)}
            type="others"
            onClickProduct={(product) => {
              sendEvent('click', item, 'Product Clicked');
              setSelectedItem(product);
              trackClickEvent();
            }}
            onClickProductAction={() => {
              if (onLoading) return;
              handleClickProductAction(item);
            }}
          />;
        })}
      </Row>

      {isEmpty(selectedItem) ? null : <ProductChevronPopup
        products={displayItems}
        productIndex={findIndex(displayItems, selectedItem)}
        isSelected={(item) => isSelected(item)}
        onClose={() => setSelectedItem(null)}
        closeOnClickOutside={true}
        handleLoadNextPage={() => { }}
        isEnd={findIndex(displayItems, selectedItem) === displayItems.length - 1}
        onClickProductAction={() => handleClickProductAction(selectedItem, true)}
      />}
    </>
  );
}

export default CustomHits;
